import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';

import { startYearSelector } from '../../Selectors';

import { descriptions, headlines, years } from '../../config';
import { fetchImage } from '../../utils';

import './ResultText.styl';

class ResultText extends PureComponent {
  constructor() {
    super();
    this.preloadImages();
  }

  preloadImages = async () => {
    for (let year of years) {
      const url = require(`~/assets/images/${year}.jpg`);
      await fetchImage(url);
    }
  }

  render() {
    const { startYear, textRef } = this.props;
    const imgSrc = startYear && require(`~/assets/images/${startYear}.jpg`);

    return (
      <div ref={textRef} className="result-textbox">
        <h4 className="result-headline">{headlines[startYear]}</h4>
        <p className="result-text">
          <span className="result-image" style={{ backgroundImage: `url(${imgSrc})` }} /> {descriptions[startYear]}
        </p>
      </div>
    );
  }
}

export default connect(state => ({
  startYear: startYearSelector(state),
}))(ResultText);
